"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nReact = void 0;
const app_platform_i18n_core_1 = require("@semios/app-platform-i18n-core");
const makePhrasesComponent_1 = require("./makePhrasesComponent");
const makePhrasesComponentPlaceholder_1 = require("./makePhrasesComponentPlaceholder");
class I18nReact extends app_platform_i18n_core_1.I18nCore {
    constructor(o) {
        super({
            ...o,
            makeInitOptions: (defaultInitOptions) => {
                const { interpolation: interpolationDefaults, react: reactDefaults, ...restOfDefaults } = defaultInitOptions;
                const initOverrides = o.makeInitOptions ? o.makeInitOptions(defaultInitOptions) : {};
                const { interpolation: interpolationOverrides, react: reactOverrides, ...restOfOverrides } = initOverrides;
                return {
                    interpolation: {
                        ...interpolationDefaults,
                        escapeValue: false,
                        ...interpolationOverrides,
                    },
                    react: {
                        ...reactDefaults,
                        bindI18n: false,
                        bindI18nStore: false,
                        transEmptyNodeValue: '',
                        transSupportBasicHtmlNodes: true,
                        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
                        useSuspense: false,
                        ...reactOverrides,
                    },
                    ...restOfDefaults,
                    ...restOfOverrides,
                };
            },
            makeCustomTranslation: (o2) => {
                const customTranslation = {
                    Phrases: o2.namespaces.reduce((acc, namespace) => {
                        return {
                            ...acc,
                            [namespace]: (0, makePhrasesComponent_1.makePhrasesComponent)(o2.i18nInstance, namespace, o2.lng),
                        };
                    }, {
                        placeholder: (0, makePhrasesComponentPlaceholder_1.makePhrasesComponentPlaceholder)(o2.i18nInstance, o2.lng),
                    }),
                    ...o.makeCustomTranslation(o2),
                };
                return customTranslation;
            },
        });
    }
}
exports.I18nReact = I18nReact;
//# sourceMappingURL=index.js.map